export default __webpack_public_path__ + "static/media/RecipeBook-full.db246350.jpg";